// SPDX-License-Identifier: AGPL-3.0-or-later
// parley fork switches for upstream code paths (see web/FORK.md).

/**
 * The desktop app (web/desktop) is installed and updated by the launcher,
 * not from a download page in the client, so upstream's download prompts
 * stay hidden.
 */
export const PARLEY_DESKTOP_APP = false;

/** Where upstream's support links point on this instance. */
export const PARLEY_SUPPORT_EMAIL = 'support@hirax.chat';

/**
 * parley has no translation project of its own; the hint pointing at
 * Fluxer's Weblate would be wrong here, so the notice stays hidden until
 * there is one ({url, domain}).
 */
export const PARLEY_TRANSLATION_SITE: {url: string; domain: string} | null = null;

/** Domains whose links open without the "leaving parley" warning. */
export const PARLEY_TRUSTED_DOMAINS = ['hirax.chat', '*.hirax.chat', 'ahri.cloud', '*.ahri.cloud'] as const;

/**
 * Username, tag, display name and avatar live at the identity provider
 * (auth.ahri.cloud); the backend rejects changes to them in PATCH /users/@me.
 */
export const PARLEY_IDENTITY_MANAGED_EXTERNALLY = true;

/** Where users edit the identity fields above. */
export const PARLEY_IDENTITY_PROVIDER_URL = 'https://auth.ahri.cloud/';

/** Whether this origin serves a production build whose version.json can be polled. */
export function isParleyWebHost(host: string): boolean {
	return host !== '' && !/^(localhost|127\.0\.0\.1|\[::1\])(:\d+)?$/.test(host);
}
